import { gql } from '@apollo/client';

export const SELLER_ORDERS_QUERY = gql`
  query SellerOrders(
    $page: Int = 1
    $pageSize: Int = 25
    $filter: OrderFilterInput
    $sort: OrderSortInput 
  ) {
    sellerOrders(
      page: $page
      pageSize: $pageSize
      filter: $filter
      sort: $sort
    ) {
      orders {
        order_id
        order_number
        customer_name
        date_order
        state
        order_status {
          code
          label
        }
        payment_status {
          code
          label
        }
        payment_method {
          label
          code
        }
        shipping_method {
          label
          code
        }
        total_amount
        total_seller_amount
        total_commission
        has_transaction_id
      }
      pagination {
        current_page
        size
        total_count
        total_pages
      }
      order_state_counts {
        code
        label
        count
      }
    }
  }
`;
